import { useInfiniteQuery } from 'react-query';
import queryKeys from '@/constants/queryKeys';
import { getSessionToken } from '@/utils/http';
import { httpClient } from '@/httpClient';
import { API_ROUTES } from '@/constants/api-routes';
import {
  IGenericResponseWithData,
  InfiniteQueryResponse,
} from '@/types/common';

export const useGetUserTemplatesQuery = (searchText?: string) => {
  return useInfiniteQuery<InfiniteQueryResponse<any>>(
    [queryKeys.TEMPLATE_GALLERY_USER_TEMPLATES, searchText],
    async ({ pageParam = {} }) => {
      const token = await getSessionToken();
      const { data } = await httpClient.get<
        IGenericResponseWithData<InfiniteQueryResponse<any>>
      >(API_ROUTES.GET_USER_TEMPLATES, {
        params: {
          ...pageParam,
          ...(searchText && { q: searchText }),
        },
        headers: {
          sessionToken: token?.data,
        },
      });
      if (!data.success) {
        throw new Error(data.message);
      }
      return data.data;
    },
    {
      getNextPageParam: (lastPage): Record<string, string> | null => {
        const nextQuery =
          lastPage.hasMore && lastPage.nextQuery
            ? Object.fromEntries(new URLSearchParams(lastPage.nextQuery))
            : null;
        return nextQuery;
      },
    },
  );
};
